const template = `<div class="lbs-notification-bar lbs-dismissable">
    <div class="lbs-status-icon lbs-status-icon-medium lbs-status-icon-$TYPE"></div>
    <h4>$MESSAGE</h4>
    <button class="lbs-notification-dismiss-button"></button>
</div>`;

export const createNotificationBar = (type, message) => {
  const container = document.createElement('div');
  container.innerHTML = template.replace('$TYPE', type).replace('$MESSAGE', message);

  // Center this on the bottom of the uScope div.
  Object.assign(container.style, {
    zIndex: 9999,
    position: 'absolute',
    minWidth: '560px',
    left: '25%',
    right: '25%',
    bottom: 0,
    height: '60px'
  });

  // Wire up the close button.
  const closeButton = container.querySelectorAll('.lbs-notification-dismiss-button')[0];
  closeButton.addEventListener('click', () => {
    ui.hide();
  });

  // Animate this thing.
  const notification = container.querySelectorAll('div')[0];

  const ui = {
    show () {
      notification.classList.add('lbs-animate-enter');
      setTimeout(() => {
        notification.classList.remove('lbs-animate-enter');
      }, 5);
    },
    hide () {
      // Start animating slide down
      notification.classList.add('lbs-animate-leaving');
      // Add handler to remove toast when animation completes
      notification.addEventListener('transitionend', () => container.remove());
      // in case the animation event doesn't fire, force clean up
      setTimeout(() => container.remove, 1000);
    },
    remove () {
      container.remove();
    },
    container
  };

  return ui;
};



// WEBPACK FOOTER //
// ./src/uScope/js/components/notification-bar/create-notification-bar.js